<template>
    <div>
        <v-switch
            class="mt-0"
            label="Pay with Bank Transfer"
            hide-details
            color="primary"
            :value="value"
            @change="onChange"
        ></v-switch>
        <p class="subtitle-2 pl-11" style="color: rgba(0,0,0,.6);">
            Turn on to use Bank Transfer if you don't have a debit card
        </p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            optionName: 'do_not_have_debit_card',
            value: false,
        };
    },
    mounted() {
        this.get();
    },
    methods: {
        async get() {
            try {
                this.$emit('loading');
                const { data: options } = await window.Vue.backendApi()
                        .user(this.$store.state.user.id)
                        .getOptions({ name: this.optionName });

                if (options[0]) {
                    this.value = options[0].value;
                } else {
                    this.value = true;
                }
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error loading user options',
                    text: err,
                });
            } finally {
                this.$emit('loaded');
            }
        },
        async onChange(value) {
            this.value = value;

            try {
                this.$emit('loading');
                await Vue.backendApi()
                    .user(this.$store.state.user.id)
                    .storeOptions({
                        options: [
                            {
                                key: this.optionName,
                                value,
                            },
                        ],
                    });

                if (value) {
                    this.$router.push({
                        name: 'offers-create',
                    });
                }

            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error saving user options',
                    text: err,
                });
            } finally {
                this.$emit('loaded');
            }
        },
    },
};
</script>

<style scoped>
.v-input.v-input--switch >>> .v-input__control label {
    color: #000 !important;
}
</style>
